// src/components/admin/PrintFichasNoivos.js

import React from 'react';
import brasao from '../../assets/brasao_hd.png';

const CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Times New Roman', serif; color: #1a1a1a; background: white; }
  @page { size: A4 portrait; margin: 0; }

  .ficha-page {
    width: 210mm;
    min-height: 297mm;
    padding: 14mm 16mm;
    page-break-after: always;
    position: relative;
    background: white;
  }
  .ficha-page:last-child { page-break-after: avoid; }

  .ficha-header {
    display: flex;
    align-items: center;
    gap: 14px;
    border-bottom: 2.5px solid #1a3a6b;
    padding-bottom: 10px;
    margin-bottom: 14px;
  }
  .ficha-header img { width: 68px; height: 68px; object-fit: contain; }
  .ficha-header h1 { font-size: 12.5pt; color: #1a3a6b; margin: 0 0 2px; font-weight: bold; }
  .ficha-header p { font-size: 8pt; color: #555; margin: 1px 0; }
  .ficha-num { margin-left: auto; font-size: 8pt; color: #888; white-space: nowrap; }

  .ficha-title {
    text-align: center;
    font-size: 11pt;
    font-weight: bold;
    color: #1a3a6b;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 12px;
    padding: 5px 0;
    border-top: 1px solid #c9a030;
    border-bottom: 1px solid #c9a030;
  }
  .turma-badge {
    background: #c9a030;
    color: #1a1a1a;
    font-size: 8pt;
    font-weight: bold;
    padding: 2px 10px;
    border-radius: 3px;
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }

  .section { margin-bottom: 12px; }
  .section-title {
    font-size: 8pt;
    font-weight: bold;
    color: #1a3a6b;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    border-bottom: 1px solid #1a3a6b;
    margin-bottom: 7px;
    padding-bottom: 2px;
  }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 20px; }
  .grid3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 4px 14px; }
  .field { display: flex; flex-direction: column; margin-bottom: 5px; }
  .field label { font-size: 7pt; color: #777; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 1px; }
  .field span { font-size: 9.5pt; font-weight: bold; border-bottom: 0.5px solid #ccc; padding-bottom: 2px; min-height: 15px; }

  .casal-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .casal-box {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 10px 12px;
    background: #fafafa;
  }
  .casal-box-title {
    font-size: 8pt;
    font-weight: bold;
    color: #1a3a6b;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 8px;
    padding-bottom: 3px;
    border-bottom: 1px solid #1a3a6b;
  }

  .comunhao-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 9pt;
    margin-top: 4px;
  }
  .check { display: inline-block; width: 13px; height: 13px; border: 1.5px solid #555; border-radius: 2px; vertical-align: middle; }
  .check-yes { background: #1a3a6b; }

  .obs-box { border: 0.5px solid #ccc; height: 36px; border-radius: 3px; margin-top: 4px; }
  .footer {
    position: absolute;
    bottom: 10mm;
    left: 16mm;
    right: 16mm;
    border-top: 0.5px solid #ccc;
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    font-size: 7pt;
    color: #999;
  }
`;

const FichaPage = ({ inscricao, numero, total }) => {
  const fmt = (d) => {
    if (!d) return '—';
    let s = String(d).trim();
    if (s.includes('T')) s = s.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, day] = s.split('-');
      return `${day}/${m}/${y}`;
    }
    return s;
  };

  const comunhaoSim = (val) => val === 'Sim' || val === 'sim' || val === true || val === 'true';

  return (
    <div className="ficha-page">
      {/* Cabeçalho */}
      <div className="ficha-header">
        <img src={brasao} alt="Brasão" />
        <div>
          <h1>Paróquia Nossa Senhora da Conceição</h1>
          <p>Messejana – Fortaleza, CE &nbsp;|&nbsp; R. Joaquim Bezerra, 235</p>
          <p>📱 (85) 98134-6247 &nbsp;|&nbsp; www.paroquiademessejana.com.br</p>
        </div>
        <div className="ficha-num">Ficha {numero}/{total}</div>
      </div>

      {/* Título */}
      <div className="ficha-title">
        Ficha de Inscrição — Curso de Noivos
        <span className="turma-badge">Turma: {inscricao.turmaNome || '—'}</span>
      </div>

      {/* Datas */}
      <div className="section">
        <div className="grid2">
          <div className="field">
            <label>Data do Casamento</label>
            <span>{fmt(inscricao.dataCasamento)}</span>
          </div>
          <div className="field">
            <label>Data da Inscrição</label>
            <span>{fmt(inscricao.dataCriacao)}</span>
          </div>
        </div>
      </div>

      {/* Dados do casal */}
      <div className="section">
        <div className="section-title">Dados do Casal</div>
        <div className="casal-grid">
          {/* Noivo */}
          <div className="casal-box">
            <div className="casal-box-title">💍 Noivo</div>
            <div className="field">
              <label>Nome Completo</label>
              <span>{inscricao.nomeNoivo || '—'}</span>
            </div>
            <div className="field">
              <label>Endereço</label>
              <span>{inscricao.enderecoNoivo || '—'}</span>
            </div>
            <div className="field">
              <label>Telefone / WhatsApp</label>
              <span>{inscricao.telefoneNoivo || '—'}</span>
            </div>
            <div className="comunhao-box">
              <div className={`check${comunhaoSim(inscricao.comunhaoNoivo) ? ' check-yes' : ''}`} />
              <span style={{ fontSize: '8.5pt' }}>
                Primeira Comunhão: <strong>{comunhaoSim(inscricao.comunhaoNoivo) ? 'Sim' : 'Não'}</strong>
              </span>
            </div>
          </div>

          {/* Noiva */}
          <div className="casal-box">
            <div className="casal-box-title">💍 Noiva</div>
            <div className="field">
              <label>Nome Completo</label>
              <span>{inscricao.nomeNoiva || '—'}</span>
            </div>
            <div className="field">
              <label>Endereço</label>
              <span>{inscricao.enderecoNoiva || '—'}</span>
            </div>
            <div className="field">
              <label>Telefone / WhatsApp</label>
              <span>{inscricao.telefoneNoiva || '—'}</span>
            </div>
            <div className="comunhao-box">
              <div className={`check${comunhaoSim(inscricao.comunhaoNoiva) ? ' check-yes' : ''}`} />
              <span style={{ fontSize: '8.5pt' }}>
                Primeira Comunhão: <strong>{comunhaoSim(inscricao.comunhaoNoiva) ? 'Sim' : 'Não'}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Observações */}
      <div className="section">
        <div className="section-title">Observações</div>
        <div className="obs-box" />
      </div>

      {/* Rodapé */}
      <div className="footer">
        <span>Paróquia N. Sra. da Conceição – Messejana</span>
        <span>Gerada em {new Date().toLocaleDateString('pt-BR')}</span>
      </div>
    </div>
  );
};

const PrintFichasNoivos = ({ inscricoes, onClose }) => {
  const pendentes = inscricoes.filter(s => s.status === 'Pendente');

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=900,height=700');
    if (!printWindow) {
      alert('Pop-up bloqueado! Permita pop-ups para este site e tente novamente.');
      return;
    }
    const fichasEl = document.getElementById('fichas-noivos-content');
    const fichasHtml = fichasEl ? fichasEl.innerHTML : '';
    printWindow.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8" />
  <title>Fichas — Curso de Noivos</title>
  <style>${CSS}</style>
</head>
<body>${fichasHtml}</body>
</html>`);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 1000);
  };

  return (
    <>
      <div style={{ position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(10,20,40,0.92)', display: 'flex', flexDirection: 'column' }}>
        {/* Barra */}
        <div style={{ background: 'var(--navy-dark)', padding: '1rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid var(--gold)', flexShrink: 0 }}>
          <div>
            <h3 style={{ color: 'var(--white)', margin: 0, fontSize: '1rem' }}>
              Fichas de Noivos — {pendentes.length} inscrição{pendentes.length !== 1 ? 'ões' : ''} pendente{pendentes.length !== 1 ? 's' : ''}
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', margin: 0 }}>Visualize antes de imprimir</p>
          </div>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button onClick={onClose} className="btn btn-sm" style={{ background: 'rgba(255,255,255,0.1)', color: 'var(--white)', border: '1px solid rgba(255,255,255,0.2)' }}>✕ Fechar</button>
            <button onClick={handlePrint} className="btn btn-primary btn-sm" disabled={pendentes.length === 0}>🖨️ Imprimir todas</button>
          </div>
        </div>

        {/* Preview */}
        <div style={{ overflowY: 'auto', padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          {pendentes.length === 0 ? (
            <div style={{ color: 'rgba(255,255,255,0.5)', padding: '4rem', textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📋</div>
              <p>Nenhuma inscrição pendente.</p>
            </div>
          ) : (
            pendentes.map((insc, i) => (
              <div key={insc.id || i} style={{ background: 'white', boxShadow: '0 8px 32px rgba(0,0,0,0.5)', transform: 'scale(0.72)', transformOrigin: 'top center', marginBottom: '-200px' }}>
                <FichaPage inscricao={insc} numero={i + 1} total={pendentes.length} />
              </div>
            ))
          )}
          <div style={{ height: '2rem' }} />
        </div>
      </div>

      {/* Conteúdo para impressão */}
      <div id="fichas-noivos-content" style={{ position: 'absolute', left: '-9999px', top: 0, background: 'white' }}>
        {pendentes.map((insc, i) => (
          <FichaPage key={insc.id || i} inscricao={insc} numero={i + 1} total={pendentes.length} />
        ))}
      </div>
    </>
  );
};

export default PrintFichasNoivos;
